import {yupResolver} from '@hookform/resolvers/yup'
import AddBoxIcon from '@mui/icons-material/AddBox'
import {styled} from '@mui/material'
import Button from 'components/Control/Button'
import Dialog from 'components/Display/Dialog/Dialog'
import {genderKod} from 'constants/users'
import {useCallback, useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import {useNavigate} from 'react-router-dom'
import NewClientForm from 'screens/Client/NewClientForm'
import analyticsService from 'services/analytic'
import {findKey} from 'services/utils/formUtils'
import {clientSchema} from 'services/utils/validationsSchemas'
import {useCreateClientMutation, useI18n} from 'store/Store'

const AddClientButton = ({width = 120, ...p}) => {
    const navigate = useNavigate()
    const {i18n} = useI18n()
    const [open, setOpen] = useState(false)
    const [errorMessage, setErrorMessage] = useState()

    const {
        control,
        formState: {errors: formErrors, isValid},
        handleSubmit,
        watch,
        reset,
    } = useForm({
        mode: 'all',
        resolver: yupResolver(clientSchema),
    })

    const [
        doCreateClient,
        {data: createClientResponse, error: clientCreateError},
    ] = useCreateClientMutation()

    const spouseNameValue = watch('spousename')

    const toggleOpenNewClient = useCallback(() => {
        setErrorMessage(null)
        setOpen(!open)
        if (open) {
            analyticsService.navToolPressed('create_new_client')
        }
    }, [open])

    const onSubmit = (values) => {
        const GenderKod = findKey(genderKod, values.GenderKod)
        doCreateClient({...values, GenderKod})
    }

    const submit = (values) => {
        analyticsService.newClientPressedSave()
        handleSubmit(onSubmit)(values)
    }

    useEffect(() => {
        if (createClientResponse) {
            setOpen(false)
            console.log('create client response', createClientResponse)
            navigate(`/client/${createClientResponse.PlannerClientKey}`)
        }
    }, [createClientResponse, navigate])

    useEffect(() => {
        if (clientCreateError) {
            setErrorMessage(clientCreateError.data)
        }
    }, [clientCreateError])

    return (
        <>
            <ButtonContainer
                width={width}
                color="secondary"
                variant="contained"
                endIcon={<AddBoxIcon />}
                onClick={toggleOpenNewClient}
                {...p}>
                {i18n.t('header.add_client_button')}
            </ButtonContainer>

            <Dialog
                fullWidth
                maxWidth="lg"
                title={i18n.t('clients.newClient')}
                saveButtonText={i18n.t('form.save')}
                open={open}
                handleClose={toggleOpenNewClient}
                onCancel={() => {
                    reset()
                    toggleOpenNewClient()
                    analyticsService.newClientPressedCancel()
                }}
                handleSave={submit}
                isValid={isValid}
                closeOnSave={false}>
                <NewClientForm
                    formControl={control}
                    formErrors={formErrors}
                    errorMessage={errorMessage}
                    spouseName={spouseNameValue}
                    submit={submit}
                />
            </Dialog>
        </>
    )
}

export default AddClientButton

const ButtonContainer = styled(Button)`
    width: ${(props) => props.width}px;
    display: flex;
    justify-content: space-around;
    padding: 10px;
    & .MuiButton-endIcon {
        margin: 0;
        font-size: 'inherit';
    }
`
